// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1Kaqp","title":"AfterFrontImage_title__1OB6v"};